import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "@/react/components/shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@/react/components/shared/BuilderUI/StyleValue.types";
import { primaryBlockDefaultStyles } from "../../constants";

export interface HomepageBlock8Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock8 = forwardRef<HTMLDivElement, HomepageBlock8Props>(
  ({ header, content, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-6 md:wb-grid md:wb-grid-cols-3 md:wb-gap-[1.875rem]">
                {content}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock
                block={footer}
                render={block => (
                  <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-8">
                    <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 md:wb-gap-16">
                      {block}
                    </div>
                  </div>
                )}
              />
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock8.displayName = "HomepageBlock8";
